import { ID } from "common/entities/IEntity";
import { Entity, Field } from "typegraph";

@Entity({update: "waiting_list"})
export class WaitingList {

	@Field()
	public entityId: ID;  
	@Field()
	public message: String;    

}


// WEBPACK FOOTER //
// ./src/panels/catalog/entities/WaitingList.ts